import React from "react";

const About = () => {
  return (
    <div className="about-container">
      <h2>About Me</h2>
      <p>
        Welcome to my portfolio! I am passionate about web development and love creating beautiful and functional websites.
      </p>
      <p>
        Here are some key points about me:
      </p>
      <ul>
        <li>I have experience with HTML, CSS, JavaScript, and React.</li>
        <li>I enjoy solving complex problems and collaborating with others.</li>
        <li>When I'm not coding, I love hiking and exploring new places.</li>
      </ul>
      <p>
        Feel free to explore my projects and get in touch if you'd like to work together!
      </p>
    </div>
  );
};

export default About;
